import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      flex: '1 1 auto',
      minWidth: 'min-content',
      userSelect: 'none',
      cursor: 'grab',

      display: 'flex',
      mozFlexDirection: 'column',
      webkitFlexDirection: 'column',
      msFleDirection: 'column',
      flexDirection: 'column',
      minHeight: 'calc(100vh - 300px)',
    },
    loginForm: {
      minWidth: 500,
      display: 'flex',
      flexDirection: 'column',
    },
    formControl: {
      width: '100%',
      margin: '10px 0px',
    },
    tableContainer: { maxHeight: 700 },
    flex: {
      flex: 1,
    },
    underlined: {
      textDecoration: 'underline',
      color: theme.palette.primary.main,
    },
    taxTitle: {
      fontWeight: 'bold',
    },
    taxText: {
      margin: '5px 5px 5px 10px',
    },
    editButton: {
      width: '70%',
      margin: 10,
      color: 'white',
      backgroundColor: theme.palette.primary.light,
    },
    groupLabel: {
      color: theme.palette.primary.light,
      fontWeight: 'bold',
      justifyContent: 'center',
      display: 'flex',
      margin: '10px 0px',
    },
  }),
);
export default useStyles;
